import * as React from "react";

export interface ITaskProps {
    id: string,
    name: string,
    description?: string,
    min: number,
    max: number,
    current: number,
    active: boolean,
    speed?: string,
    left?: string,
    complete?: boolean
}

export default function Task(props: ITaskProps) {
    const ratio = (props.current - props.min) / (props.max - props.min);
    const circumference = 340.2;
    const proglength = 1 - (ratio * circumference);
    const pct = Math.round(100 * ratio);

    return <div className="task">
        <div className="info">
            <h1>{props.name}</h1>
            <p>{props.description}</p>
        </div>
        {
            props.speed && <div className="speed">
                Current speed: {props.speed}
            </div>
        }
        <div className="progress">
            <svg width="130" height="130" viewBox="0 0 130 130">
                <circle cx="65" cy="65" r="54" fill="none" stroke="#f77a52" stroke-width="15" />
                <circle cx="65" cy="65" r="54" fill="none" stroke="#e6e6e6" stroke-width="15"
                    stroke-dasharray={circumference} stroke-dashoffset={proglength}
                    transform="rotate(-90 65 65)" />
                <text fontSize="20" fontWeight="lighter" x="65" y="65" width="130" textAnchor="middle" dominantBaseline="middle">{pct} %</text>
            </svg>
        </div>
    </div>;
}


// WEBPACK FOOTER //
// ./src/bits/task.tsx